export default __webpack_public_path__ + "static/media/Short Stay Visa - Home Page.62c228b7.jpg";